<template>
    <div :class="css.container" class="relative" ref="container">
        <!-- * 主体 -->
        <div :class="[css.inputs, visible && css.active, style == 'style1' && 'ui-form-control']">
            <!-- * 检索图标 -->
            <ui-icon :class="css.icon" class="icon-search" name="search-big" @click="$emit('search', keyword, mode)" />
            <!-- * 输入窗口 -->
            <ui-input :class="css.input" ref="input" size="large" v-on="ons.input" v-bind="binds.input" v-model="keyword" />
            <!-- * 选择器 -->
            <ui-select
                v-if="style == 'style1'"
                v-model="mode"
                ref="select"
                size="large"
                :width="144"
                :class="css.select"
                :candidates="vars.mode"
                :class-extra-name="css.selects"
                @change="candidates = []">
                <template #candidate="{ data }">
                    <span v-html="data.label"></span>
                </template>
            </ui-select>
        </div>

        <!-- * 选择项 -->
        <Transition v-on="animations.selector(true)">
            <div :class="css.options" v-bind="binds.options" v-show="visible && candidates?.length" ref="options" @scroll="methods.more">
                <div :class="css.option" v-for="(data, key) in candidates" :key="key" @mousedown="methods.select(data)">
                    <div :class="data.alias && data.type == 'gene' && css.name" class="ellipsis">
                        <UiIcon v-if="data.type" :name="data.type" :class="[css.icon, css[data.type]]" />
                        <span :title="`${data.label}${data.species ? ` [${useSpeciesName(data.species)}]` : ''}`">
                            <span v-html="methods.replace_name(data.label)"></span>
                            <span v-if="data.species" style="padding-left: 8px">[{{ useSpeciesName(data.species) }}]</span>
                        </span>
                    </div>

                    <div v-if="data.alias && data.type == 'gene'" :class="css.alias" class="ellipsis" v-html="data.alias" :title="data.alias"></div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiSelect, UiInput, UiIcon, animations } from "various-ui";
//* 组件属性
import { SelectSearchPropsOption, SelectSearchEmits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import style1 from "./style/index.module.less";
import style2 from "./style/index2.module.less";

//* 组件属性注册
const define = defineProps(SelectSearchPropsOption);
const emit = defineEmits(SelectSearchEmits);

const css = define.style == "style1" ? style1 : style2;

//* 组合函数
const { ons, vars, refs, nodes, binds, methods } = useComposable(define, emit);
const { candidates, visible, keyword, mode } = refs;
const { input, select, options, container } = nodes;

//* 组件初始化
methods.init();
onBeforeUnmount(() => {
    //* 接口请求取消
    vars.controller?.abort();
    //* 事件监听取消
    removeEventListener("resize", methods.resize, true);
});

//* 组件挂载
onMounted(() => {
    methods.resize();
    addEventListener("resize", methods.resize, true);
});

//* 组件属性导出
defineExpose({
    blur: () => {
        select.value?.hidden();
        input.value?.blur();
    },
});
</script>
